<p>whisky-edit works!</p>
<p>Whisky id: {{this.whiskyId}}</p>
